import Com from './index.vue'
import { withInstall } from '../utils'

export * from './event'

export const DownloadCenter = withInstall(Com)
